module.exports = __webpack_public_path__ + "static/media/banner_2.ece424c6.jpg";